import { render, staticRenderFns } from "./edittrailer.vue?vue&type=template&id=4e65c380&scoped=true&"
import script from "./edittrailer.js?vue&type=script&lang=js&"
export * from "./edittrailer.js?vue&type=script&lang=js&"
import style0 from "./edittrailer.vue?vue&type=style&index=0&id=4e65c380&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e65c380",
  null
  
)

export default component.exports